import {TApiResponseModel} from '../../typings/models/common/t-api-response-model';

export class TApiRequestModelExtensions<T> {
  private constructor() {}

  static buildUrlFromModel(
    action: string,
    dtoList?: any[] | null
  ): string {
    if (!dtoList) return action;

    let url = action;
    let queryParams: string[] = [];

    for (let index = 0; index < dtoList.length; index++) {


      for (const [key, value] of Object.entries(dtoList[index])) {
        if (value === undefined || value === null) continue;

        const placeholder = `{${key}}`;

        if (url.includes(placeholder)) {
          url = url.replace(placeholder, encodeURIComponent(String(value)));
        } else {
          queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
        }
      }

      if (queryParams.length > 0) {
        if (index !== 0) {
          url += '&';
        }
        url += (url.includes('?') ? '&' : '?') + queryParams.join('&');
      }

      queryParams = [];
    }


    return url;
  }
}
